import { mediaQuery } from '@ycos/themes';
import { themes } from '@ynap/fela';

export const formatScreens = (screens, brandId) => {
    const mediaQueryMapper = getMediaQueriesList(brandId);
    return Object.keys(screens).reduce((acc, key) => (mediaQueryMapper[key] ? [...acc, { child: screens[key], mediaQuery: mediaQueryMapper[key] }] : acc), []);
};

const getMediaQueriesList = (brandId) => {
    const minMediaQueries = mediaQuery.min(themes[brandId].breakpoints);
    const maxMediaQueries = mediaQuery.max(themes[brandId].breakpoints);

    return {
        phone: `(min-width: 0px) and ${maxMediaQueries.small}`, // BP1
        tablet: `${minMediaQueries.medium} and ${maxMediaQueries.medium}`, // BP2
        desktop: `${minMediaQueries.large}`, // BP3 and BP4
        smallerDesktop: `${minMediaQueries.large} and ${maxMediaQueries.large}`, // BP3
        largeDesktop: `${minMediaQueries.xlarge}`, // BP4
        xlargeDesktop: `${minMediaQueries.xlarge} and ${maxMediaQueries.xxlarge}`, // BP5
        xxlargeDesktop: `${minMediaQueries.xxlarge} and ${maxMediaQueries.ultra}`, // BP6
        ultraLargeDesktop: `${minMediaQueries.ultra}`, // BP7
    };
};
